module.exports = __webpack_public_path__ + "static/media/jewelry.fc197bf1.jpg";